import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportSelectionComponent } from './report-selection.component';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';



@NgModule({
  declarations: [
    ReportSelectionComponent
  ],
  imports: [
    CommonModule,
    TableModule,
    ButtonModule,
    InputTextModule
  ],
  exports: [
    ReportSelectionComponent
  ]
})
export class ReportSelectionModule { }
